import styles from './FloatingShapes.module.css';

export default function FloatingShapes({ shapes }) {
  return (
    <>
      {shapes.map((shape, i) => {
        const baseStyle = {
          position: 'absolute',
          background: shape.color,
          opacity: shape.opacity,
          animationDelay: `${shape.delay}s`,
          pointerEvents: 'none',
        };

        if (shape.type === 'circle') {
          return (
            <div
              key={i}
              className={styles.circle}
              style={{
                ...baseStyle,
                left: shape.cx,
                top: shape.cy,
                width: shape.r * 2,
                height: shape.r * 2,
                transform: 'translate(-50%, -50%)',
                borderRadius: '50%',
              }}
            />
          );
        }

        return (
          <div
            key={i}
            className={styles.rect}
            style={{
              ...baseStyle,
              left: shape.cx,
              top: shape.cy,
              width: shape.size,
              height: shape.size,
              transform: `translate(-50%, -50%) rotate(${shape.rot}deg)`,
              borderRadius: '12px',
            }}
          />
        );
      })}
    </>
  );
}
